import React, { useEffect } from 'react';

// import 'css/normalize.css';
// import 'css/base.scss';
// import 'css/toast.scss';
// import 'css/forms.scss';
// import 'css/main.scss';
import '@ygtechnologies/bygr-frontend-component-library/dist/style.css';
import '@ygtechnologies/rubus-ui/dist/style.css';

import { BaseApp, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';

import '_variables.scss';
import MainRouting from 'components/MainRouting/MainRouting';
import { useAsyncState } from 'utils/hooks';
import { getSystemInfo } from 'services/system';
import TopEnvironmentBar from 'components/TopEnvironmentBar';

const App: React.FC<{}> = () => {
    const [systemInfo] = useAsyncState(() => getSystemInfo(), [], null);

    useEffect(() => {
        document.title = systemInfo?.environmentName ? `${systemInfo?.environmentName} - MacGyver` : 'MacGyver';
    }, [systemInfo]);

    if (!systemInfo) return <LoadingIndicator />;
    return (
        <BaseApp>
            <TopEnvironmentBar systemInfo={systemInfo} />
            <MainRouting />
        </BaseApp>
    );
};

export default App;